import styled from 'styled-components';

const AttachementLabel = styled.label`
  color: #2396dc;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
  text-decoration-line: underline;
  display: flex;
  gap: 8px;
  cursor: pointer;
`;

export default AttachementLabel;
